<klt-button type="secondary" (click)="showCompareDialog()">COMPARE</klt-button>
